export const NAMESPACE = 'KanBo/Board/lists/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_DESCRIPTION = NAMESPACE + 'SET_DESCRIPTION'
export const SET_SETTINGS = NAMESPACE + 'SET_SETTINGS'

const initialState = {}

const listDefaults = {
  isLoading: false,
  isLoaded: false,
  settings: {
    color: 0,
    wipLimit: 0,
  }
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return state[action.payload.listId] ? {
        ...state,
        [action.payload.listId]: {
          ...state[action.payload.listId],
          isLoading: action.payload.isLoading,
          isLoaded: action.payload.isLoaded
        }
      } : state
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...listDefaults,
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      let newState = {
        ...state
      }
      action.payload.forEach(list => {
        newState[list.id] = {
          ...listDefaults,
          ...list
        }
      })
      return newState
    }
    case REMOVE: {
      if (!state[action.payload.id]) return state

      let newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case SET_NAME:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          name: action.payload.name
        }
      } : state
    case SET_DESCRIPTION:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          description: action.payload.description
        }
      } : state
    case SET_SETTINGS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          settings: {
            ...state[action.payload.id].settings,
            ...action.payload.settings
          }
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ listId, isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      listId,
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (cardArray) {
  return {
    type: ADD_ARRAY,
    payload: cardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setDescription ({ id, description }) {
  return {
    type: SET_DESCRIPTION,
    payload: {
      id,
      description
    }
  }
}

export function setSettings ({ id, settings }) {
  return {
    type: SET_SETTINGS,
    payload: {
      id,
      settings
    }
  }
}